<div class="not-found-container">
  <div class="logo">
    <img src="../../../../assets/images/logo-stacked-color.svg" alt="TechInsights"/>
  </div>
  <div class="access-denied-logo"><img src="assets/access-denied/403.svg" alt="unauthorized"/></div>
  <h1>Access Denied</h1>
  <p>You don’t have access to this page. Please contact support if this wasn’t supposed to happen.</p>
  <button class="button button-primary" (click)="goBack()">
    <em class="icon-left_large"></em>
    Take me back
  </button>
</div>
